import React from 'react';
import { Puzzle, Wallet, Repeat, Hourglass } from 'lucide-react';
import Reveal from './Reveal';

const ICONS = [Puzzle, Wallet, Repeat, Hourglass];

export default function Problems({ t }) {
  const p = t.problems;

  return (
    <section className="relative bg-abyss py-24 lg:py-32 overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] rounded-full bg-pulse-500/8 blur-[140px] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="max-w-3xl mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full border border-pulse-400/40 bg-pulse-500/10 text-pulse-400 text-xs font-bold uppercase tracking-[0.18em] mb-5">
              {p.kicker}
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-frost tracking-tight leading-tight">
              {p.title}
            </h2>
            <p className="mt-5 text-lg text-mist leading-relaxed">{p.sub}</p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {p.items.map((item, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={item.title} delay={i * 90}>
                <div className="group relative h-full rounded-3xl border border-line bg-surface p-7 overflow-hidden hover:border-pulse-400/40 transition-colors duration-300">
                  <span className="absolute -top-4 -right-2 font-display text-8xl font-bold text-white/[0.04] select-none group-hover:text-pulse-500/10 transition-colors duration-300">
                    0{i + 1}
                  </span>
                  <div className="relative flex flex-col gap-5">
                    <div className="w-12 h-12 rounded-2xl bg-pulse-500/15 border border-pulse-400/30 flex items-center justify-center group-hover:bg-pulse-500/25 transition-colors duration-300">
                      <Icon size={22} className="text-pulse-400" />
                    </div>
                    <div>
                      <h3 className="font-display text-lg font-bold text-frost mb-2">{item.title}</h3>
                      <p className="text-sm text-mist leading-relaxed">{item.desc}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
